import * as React from "react";
import Dropzone from "react-dropzone";
import { FormField } from "@/components/bp/bp-ui";


export interface IUploadedFile {
    fileName: string;
    mimeType: string;
    size: number;
    contents: any;
}

interface IFileUploadProps {
    name: string;
    label?: string;
    error?: string;
    placeholderText?: string;
    fileUploaded: (name: string, data: IUploadedFile) => any;
    value: IUploadedFile;
    required?: boolean; 
}

interface IFileUploadState {
    fileName: string;
}

export class FileUpload extends React.Component<IFileUploadProps, IFileUploadState> {

    uploadControl: HTMLInputElement;

    constructor(props, context) {
        super(props, context);
        this.state = {
            fileName: '',
        };
    }

    //componentWillReceiveProps(nextProps: {readonly [P in "name" | "placeholderText" | "fileUploaded" | "value"]: IFileUploadProps[P]}, nextContext): void {
    //    if (nextProps.value) {
    //        this.setState({
    //            fileName: nextProps.value.fileName
    //        });
    //    } else {
    //        this.setState({
    //            fileName: null
    //        });
    //    }
    //}

    triggerFileSelect = () => {
        this.uploadControl.click();
    };

    fileSelected = () => {

        var selectedFile = this.uploadControl.files[0];
        if (!selectedFile) {
            this.setState({
                fileName: ''
            });

            this.props.fileUploaded(this.props.name, null);

            return;
        }
        //console.log(selectedFile);
        var reader = new FileReader();

        reader.onload = (contents) => {
            //console.log(contents);

            var fileInfo = {
                fileName: selectedFile.name,
                contents: (contents.target as any).result,
                mimeType: selectedFile.type,
                size: selectedFile.size
            };

            this.props.fileUploaded(this.props.name, fileInfo);
            //this.setValue(fileInfo);
        };

        reader.readAsDataURL(selectedFile);

        this.setState({
            fileName: selectedFile.name
        });


    };

    dummyChange = () => {

    };

    render() {
        // return (<FormField type={'file'} control={'input'} label={this.props.label} error={this.props.error} ref={(file) => { this.uploadControl = file; }} onChange={this.fileSelected}>
        // </FormField>);

        return (<FormField name={this.props.name} error={this.props.error} required={this.props.required}>
            {this.props.label &&
                <label>{this.props.label}</label>
            }
            <Dropzone onDrop={acceptedFiles => console.log(acceptedFiles)}>
                {({ getRootProps, getInputProps }) => (
                    <div className="ui action input" {...getRootProps()}>
                        <input type="text" placeholder={this.props.placeholderText} value={this.state.fileName} onChange={this.dummyChange} readOnly onClick={this.triggerFileSelect} />
                        <input type="file" ref={(file) => { this.uploadControl = file; }} onChange={this.fileSelected} />
                        <div className="ui icon button" onClick={this.triggerFileSelect}>
                            <i className="attach icon"></i>
                        </div>
                    </div>
                )}
            </Dropzone></FormField>);
    }
}
